import apiClient from '../api';

export const getUsersInfo = () => apiClient.get(`/admin/users/info`);